// Module
var code = "<page-header title=\"'堆栈列表'\" breadcrumbs=\"['堆栈']\" reload=\"true\"> </page-header>\r\n\r\n<docker-stacks-datatable\r\n  ng-if=\"stacks\"\r\n  dataset=\"stacks\"\r\n  is-image-notification-enabled=\"enableImageNotification\"\r\n  on-remove=\"(removeAction)\"\r\n  on-refresh=\"(getStacks)\"\r\n></docker-stacks-datatable>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/views/stacks/stacks.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;